"use strict";

// スクロール値が現在地より大きくなったら、gnavにis-hiddenクラスを付与する
// スクロール値が現在地より小さくなったら、gnavからis-hiddenクラスを削除する
document.addEventListener('DOMContentLoaded', () => {
      const gnav = document.querySelector('.js-gnav');
      const fHero = document.querySelector('.f-hero');
      let lastScrollY = window.scrollY;

      // f-heroがビューポート内に1pxでも入っているかを判定
      const isFHeroInView = () => {
            if (!fHero) return false;
            const rect = fHero.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
      };

      window.addEventListener('scroll', () => {
            const currentScrollY = window.scrollY;
            const body = document.body;
            if (isFHeroInView()) {
                  // f-heroが画面内にある間は常に非表示
                  gnav.classList.add('is-hidden');
            } else if (currentScrollY === 0) {
                  // 最上部では必ず表示
                  gnav.classList.remove('is-hidden');
            } else if (currentScrollY > lastScrollY) {
                  // 下スクロール
                  gnav.classList.add('is-hidden');
                  // bodyにis-openが付与されていれば削除
                  if (body.classList.contains('is-open')) {
                        body.classList.remove('is-open');
                  }
            } else if (currentScrollY < lastScrollY) {
                  // 上スクロール
                  gnav.classList.remove('is-hidden');
            }
            lastScrollY = currentScrollY;
      });
});

window.addEventListener('load', () => {
      const gnav = document.querySelector('.js-gnav');
      const fHero = document.querySelector('.f-hero');

      // 初期表示時もf-heroの可視状態に合わせて表示状態を同期
      setTimeout(() => {
            if (!fHero) {
                  gnav.classList.remove('is-hidden');
                  return;
            }

            const rect = fHero.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
                  gnav.classList.add('is-hidden');
            } else {
                  gnav.classList.remove('is-hidden');
            }
      }, 1000);
});